import * as React from 'react';
import { ENV, SUPPORT_EMAIL } from '../../config';
import { sendEmail } from '../../utils';

interface OwnProps {
  info?: string;
  fallback?: React.ReactNode;
  children?: React.ReactNode;
}

type Props = OwnProps;

class ErrorBoundary extends React.Component<Props, { hasError: boolean }> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    if (ENV !== 'development') {
      sendEmail(
        ['prajwal@flayr.io'],
        'Error occured on React App',
        `${error} <br /> ${JSON.stringify(errorInfo)} <br /> ${
          this.props.info || ''
        }`
      );
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (this.props.fallback && <>{this.props.fallback}</>) || null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
